    <div class="attendance-container">
      <!-- Header Section -->
      <header class="attendance-header">
        <div class="header-left">
          <h1>{{ greetingText }}</h1>
          <p class="subtitle-text">Track and manage your attendance records.</p>
        </div>
      </header>

      <!-- Main Content -->
      <main class="main-content-row">
        <!-- Check-in and Hours Section -->
        <section class="content-row first-row">
          <!-- Check In/Out Card -->
          <div class="check-in-card">
            <div class="check-in-image">
              <img 
                [src]="attendanceImage" 
                [alt]="greeting + ' Check In Illustration'"
                loading="lazy">
            </div>
            <div class="check-in-content">
              <div class="date-time-info">
                <span class="paragraph-p5-regular">{{ currentDateString }}</span>
                <span class="heading-h6-semibold">{{ currentTimeString }}</span>
              </div>
              
              <!-- Check In/Out Button -->
              <button 
                *ngIf="isInitialLoadComplete"
                class="check-in-btn" 
                [class.checked-in]="isCheckedIn"
                [disabled]="isLoading"
                (click)="isCheckedIn ? clockOut() : clockIn()"
                type="button">
                <span>{{ buttonText }}</span>
                <img 
                  *ngIf="isCheckedIn" 
                  src="/assets/images/sign-out.png" 
                  alt="Sign Out" 
                  class="checkout-icon">
              </button>
              
              <!-- Loading State -->
              <div *ngIf="!isInitialLoadComplete" class="loading-button">
                <div class="loading-spinner" aria-hidden="true"></div>
                <span>Loading...</span>
              </div>
            </div>
          </div>

          <!-- Hours Summary Card -->
          <div class="hours-card">
            <div class="hours-item">
              <div class="hours-label">Hours clocked</div>
              <div class="hours-value">{{ currentWorkHours }}</div>
            </div>
            <div class="hours-separator"></div>
            <div class="hours-item">
              <div class="hours-label">Break hours</div>
              <div class="hours-value">{{ currentBreakHours }}</div>
            </div>
          </div>
        </section>

        <!-- Calendar and Timeline Section -->
        <section class="content-row second-row">
          <!-- Calendar -->
          <div class="calendar-section">
            <app-attendance-calendar
              [attendanceData]="attendanceData"
              [currentMonth]="currentMonth"
              [selectedDate]="selectedDate"
              [today]="attendanceToday"
              (dateSelected)="onDateSelected($event)"
              (monthChanged)="onMonthChanged($event)">
            </app-attendance-calendar>
          </div>

          <!-- Daily Details -->
          <div class="daily-details-section">
            <header class="daily-details-header">
              <h3>{{ selectedDateString }}</h3>
            </header>
            
            <!-- Daily Summary -->
            <div 
              *ngIf="dailyRecords.length > 0" 
              class="daily-summary" 
              [@fadeInOut]>
              <span class="summary-text">
                <span class="summary-label">Total:&nbsp;</span> 
                <span class="summary-value">{{ totalHours }}</span>
              </span>
              <span class="summary-separator" aria-hidden="true"></span>
              <span class="summary-text">
                <span class="summary-label">Break:&nbsp;</span> 
                <span class="summary-value">{{ breakHoursDisplay }}</span>
              </span>
            </div>
            
            <!-- Daily Timeline -->
            <div class="daily-table" [@fadeInOut]>
              <!-- Table Header -->
              <div *ngIf="dailyRecords.length > 0" class="table-header">
                <span class="header-label">In/ Out</span>
                <span class="header-label">Time</span>
              </div>
              
              <!-- Attendance Records List -->
              <div *ngIf="dailyRecords.length > 0" class="attendance-list">
                <ng-container *ngFor="let record of dailyRecords; let i = index; trackBy: trackBySessionIndex">
                  <div class="attendance-item">
                    <span class="attendance-type">{{ record.type }}</span>
                    <span class="attendance-time">{{ record.time }}</span>
                  </div>
                  <div 
                    *ngIf="record.type === 'Out' && i > 0" 
                    class="hours-item" 
                    [class.active-session]="calculateHours(record, dailyRecords[i-1]) === 'Active'">
                    <span class="hours-text">
                      <span class="hours-label">Hours: </span> 
                      <span class="hours-value">{{ calculateHours(record, dailyRecords[i-1]) }}</span>
                    </span>
                  </div>
                </ng-container>
              </div>
              
              <!-- Empty State -->
              <div *ngIf="dailyRecords.length === 0" class="no-data-message">
                <p>No check-ins for this date.</p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>

<!-- Success Toast -->
<app-success-toast 
  [show]="showSuccessToast" 
  [title]="toastTitle" 
  [message]="toastMessage" 
  [type]="toastType"
  (close)="onToastClose()">
</app-success-toast>